import { render } from "./NewAppointmentPage.vue?vue&type=template&id=9d12400c&scoped=true"
import script from "./NewAppointmentPage.vue?vue&type=script&lang=js"
export * from "./NewAppointmentPage.vue?vue&type=script&lang=js"

import "./NewAppointmentPage.vue?vue&type=style&index=0&id=9d12400c&scoped=true&lang=css"
import "./NewAppointmentPage.vue?vue&type=style&index=1&id=9d12400c&lang=css"

import exportComponent from "/opt/doctorsp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d12400c"]])

export default __exports__